export const VPN_PROVIDER_TYPE_VALUES = ["V2RAY", "VMESS", "SSH"];
export const INVENTORY_VPN_PROVIDER_TYPES = ["VMESS", "SSH"];
export function isInventoryProviderType(providerType) {
    return providerType === "VMESS" || providerType === "SSH";
}
export function inventoryProviderToVpnType(providerType) {
    return providerType === "VMESS" ? "vmess" : "ssh";
}
export const MANUAL_VPN_TYPE_VALUES = ["vmess", "ssh"];
export const VPN_ACCOUNT_STATUS_VALUES = ["available", "assigned"];
export const manualVpnSshSchema = {
    host: "",
    port: 22,
    username: "",
    password: "",
};
export function formatManualVpnConfig(payload) {
    if (payload.type === "vmess" && payload.vmessUrl) {
        return payload.vmessUrl;
    }
    if (payload.type === "ssh" && payload.ssh) {
        const { host, port, username, password } = payload.ssh;
        return [
            `Host: ${host}`,
            `Port: ${port}`,
            `Username: ${username}`,
            `Password: ${password}`,
        ].join("\n");
    }
    return "";
}
